import React, { memo } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { SortField, SortDirection, ColumnDefinition } from '../../types';
import { getColumnWidth } from '../../utils';
interface ExportHeaderProps {
  column: ColumnDefinition;
  currentSortField?: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
}

const ExportHeader: React.FC<ExportHeaderProps> = ({
  column,
  currentSortField,
  sortDirection,
  onSort,
}) => {
  const { label, field, sortable } = column;
  const isCurrentlySorted = currentSortField === field;

  const ariaSortValue = !sortable
    ? undefined
    : !isCurrentlySorted
    ? 'none'
    : sortDirection === 'asc'
    ? 'ascending'
    : 'descending';

  const handleSort = () => !!sortable && !!field && onSort(field as SortField);

  return (
    <th
      className={`sticky top-0 bg-neutral-50 py-4 px-2 ${
        field === 'type' ? 'pl-4' : ''
      } text-left text-xs font-semibold text-neutral-500 uppercase tracking-wider z-10 ${getColumnWidth(
        field
      )} ${
        !!sortable ? 'cursor-pointer hover:bg-neutral-100 group' : ''
      } transition-colors duration-150`}
      onClick={!!sortable ? handleSort : undefined}
      aria-sort={ariaSortValue}
      role="columnheader"
      scope="col"
    >
      <div className="flex items-center gap-2 max-w-">
        <span>{label}</span>
        {!!sortable && (
          <div className="w-3 h-3 flex items-center">
            <Icon
              icon={faArrowUp}
              aria-hidden="true"
              className={`h-3 w-3 text-neutral-400 transition-all duration-300 ${
                isCurrentlySorted
                  ? 'opacity-100'
                  : 'opacity-0 group-hover:opacity-50'
              } ${
                isCurrentlySorted && sortDirection === 'desc'
                  ? 'rotate-180'
                  : ''
              }`}
            />
          </div>
        )}
      </div>
    </th>
  );
};

export default memo(ExportHeader);
